module.exports = __webpack_public_path__ + "img/butfirstcoffee_hair.1618e164.jpg";